import React from 'react';

const Pagination = ({ total, page, perPage, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  if (totalPages <= 1) return null;

  const start = (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }

  return (
    <div className="cp-pagination">
      <span>Mostrando {start}-{end} de {total}</span>
      <div className="cp-pagination-buttons">
        <button className="cp-pagination-btn" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>Ant.</button>
        {pages.map((p, i) =>
          typeof p === 'string'
            ? <span key={`e${i}`} style={{ padding: '6px 4px', color: '#999' }}>...</span>
            : <button key={p} className={`cp-pagination-btn${p === page ? ' active' : ''}`} onClick={() => onPageChange(p)}>{p}</button>
        )}
        <button className="cp-pagination-btn" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>Sig.</button>
      </div>
    </div>
  );
};

export default Pagination;
